/* Promo PDP: imprint cascade + quantity matrix, matching promo.4over.com fields. */
(function (w) {
  function parseJson(node) {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || "{}");
    } catch (err) {
      return null;
    }
  }

  function dollarsToCents(value) {
    var n = parseFloat(value);
    if (!isFinite(n) || n <= 0) return 0;
    return Math.round(n * 100);
  }

  function gridRow(grid, qty) {
    var rows = grid || [];
    var n = parseInt(qty, 10) || 0;
    for (var i = 0; i < rows.length; i++) {
      if (parseInt(rows[i].qty, 10) === n) return rows[i];
    }
    return null;
  }

  function promoQuote(payload, args) {
    args = args || {};
    var qty = parseInt(args.qty, 10) || 0;
    var decorated = args.decorated !== false;
    var method = args.method || null;
    var row = gridRow(payload && payload.grid, qty);
    var eachCents = row ? dollarsToCents(row.retail) : 0;
    var setupCents = 0;
    var runEachCents = 0;
    if (decorated && method) {
      setupCents = dollarsToCents(method.setup_retail);
      runEachCents = dollarsToCents(method.run_retail || method.extra_color_retail);
    }
    eachCents += runEachCents;
    return {
      qty: qty,
      eachCents: eachCents,
      runEachCents: runEachCents,
      setupCents: setupCents,
      totalCents: qty > 0 ? eachCents * qty + setupCents : 0,
      row: row
    };
  }

  function fillSelect(sel, rows, nameKey, idKey) {
    if (!sel) return;
    var cur = sel.value;
    sel.innerHTML = "";
    (rows || []).forEach(function (row) {
      var opt = document.createElement("option");
      opt.value = row[nameKey] || row[idKey] || "";
      opt.textContent = row[nameKey] || row[idKey] || "";
      if (row[idKey]) opt.setAttribute("data-id", row[idKey]);
      sel.appendChild(opt);
    });
    if (cur) {
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value === cur) {
          sel.value = cur;
          return;
        }
      }
    }
    if (sel.options.length) sel.selectedIndex = 0;
  }

  function showWrap(wrap, on) {
    if (!wrap) return;
    wrap.hidden = !on;
  }

  function qtyFromVariant(root) {
    var qtySel = null;
    root.querySelectorAll("select.single-option-selector").forEach(function (el) {
      var wrap = el.closest(".selector-wrapper");
      var label = wrap && wrap.querySelector("label");
      var name = ((label && label.textContent) || "").replace(/\s+/g, " ").trim().toLowerCase();
      if (name === "quantity" || name.indexOf("quantity") === 0) qtySel = el;
    });
    var raw = qtySel ? qtySel.value : "";
    var n = parseInt(String(raw).replace(/,/g, ""), 10);
    return n > 0 ? n : 0;
  }

  function money(cents, fmt) {
    cents = Math.round(Number(cents) || 0);
    var d = (Math.abs(cents) / 100).toFixed(2);
    var out = String(fmt || "${{amount}}")
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Math.abs(cents) / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, d.replace(".", ","))
      .replace(/\{\{\s*amount\s*\}\}/g, d);
    if (out === (fmt || "${{amount}}")) out = "$" + d;
    return (cents < 0 ? "-" : "") + out;
  }

  function setField(root, key, value) {
    var el = root.querySelector('[data-ezink-promo-prop="' + key + '"]');
    if (!el) return;
    el.value = value || "";
    el.disabled = !value;
  }

  function init(root) {
    var box = root.querySelector("[data-ezink-promo-config]");
    if (!box || box.getAttribute("data-ready") === "1") return;
    var payload = parseJson(box.querySelector("[data-ezink-promo-json]"));
    if (!payload) return;
    box.setAttribute("data-ready", "1");

    var deco = box.querySelector("[data-ezink-promo-deco]");
    var locSel = box.querySelector("[data-ezink-promo-loc]");
    var methodSel = box.querySelector("[data-ezink-promo-method]");
    var inkSel = box.querySelector("[data-ezink-promo-ink]");
    var locWrap = box.querySelector("[data-ezink-promo-loc-wrap]");
    var methodWrap = box.querySelector("[data-ezink-promo-method-wrap]");
    var inkWrap = box.querySelector("[data-ezink-promo-color-wrap]");
    var setupEl = root.querySelector("[data-ezink-promo-setup]");
    var locations = (payload.imprint && payload.imprint.locations) || [];

    function decorated() {
      if (deco) return deco.value !== "Blank";
      return payload.is_decorated !== false;
    }

    function currentLoc() {
      var name = locSel && locSel.value;
      for (var i = 0; i < locations.length; i++) {
        if (locations[i].name === name || locations[i].id === name) return locations[i];
      }
      return locations[0] || null;
    }

    function currentMethod() {
      var loc = currentLoc();
      var methods = (loc && loc.methods) || [];
      var name = methodSel && methodSel.value;
      for (var i = 0; i < methods.length; i++) {
        if (methods[i].name === name || methods[i].id === name) return methods[i];
      }
      return methods[0] || null;
    }

    function paintImprint() {
      var on = decorated() && locations.length > 0;
      showWrap(box.querySelector("[data-ezink-promo-imprint]"), on);
      [locSel, methodSel, inkSel].forEach(function (sel) {
        if (sel) sel.disabled = !on;
      });
      if (!on) {
        showWrap(locWrap, false);
        showWrap(methodWrap, false);
        showWrap(inkWrap, false);
        return;
      }
      fillSelect(locSel, locations, "name", "id");
      showWrap(locWrap, locations.length > 0);
      var loc = currentLoc();
      var methods = (loc && loc.methods) || [];
      fillSelect(methodSel, methods, "name", "id");
      showWrap(methodWrap, methods.length > 0);
      var method = currentMethod();
      var colors = (method && method.colors) || [];
      fillSelect(inkSel, colors, "name", "id");
      showWrap(inkWrap, colors.length > 0);
    }

    function paintPrice() {
      var qty = qtyFromVariant(root);
      var method = decorated() ? currentMethod() : null;
      var q = promoQuote(payload, { qty: qty, decorated: decorated(), method: method });
      var wrap = root.querySelector("[data-ezink-price-wrap]");
      var fmt = wrap && wrap.getAttribute("data-money-format");
      root.querySelectorAll("[data-ezink-promo-qty]").forEach(function (tr) {
        var rowQty = parseInt(tr.getAttribute("data-ezink-promo-qty") || "0", 10);
        if (rowQty === qty) tr.classList.add("is-active");
        else tr.classList.remove("is-active");
        var unitCell = tr.querySelector("[data-ezink-promo-unit]");
        if (unitCell) {
          var base = dollarsToCents(tr.getAttribute("data-retail"));
          unitCell.textContent = money(base + q.runEachCents, fmt);
        }
      });
      if (!q.row || !qty) return;
      document.querySelectorAll("[data-ezink-price-total]").forEach(function (el) {
        el.hidden = false;
        el.textContent = money(q.totalCents, fmt);
      });
      document.querySelectorAll("[data-ezink-price-unit]").forEach(function (el) {
        el.hidden = false;
        el.textContent = "(" + money(q.eachCents, fmt) + " each)";
      });
      if (setupEl) {
        if (q.setupCents > 0 || q.runEachCents > 0) {
          setupEl.hidden = false;
          var bits = [];
          if (q.setupCents > 0) bits.push(money(q.setupCents, fmt) + " setup");
          if (q.runEachCents > 0) bits.push(money(q.runEachCents, fmt) + " each for " + ((method && method.name) || "imprint"));
          setupEl.textContent = "Includes " + bits.join(" + ") + ". One-color imprint in one location is in the piece price.";
        } else {
          setupEl.hidden = true;
        }
      }
      setField(root, "setup", q.setupCents > 0 ? money(q.setupCents, fmt) : "");
      setField(root, "run", q.runEachCents > 0 ? money(q.runEachCents, fmt) + " each" : "");
      setField(root, "quote", q.totalCents > 0 ? money(q.totalCents, fmt) : "");
    }

    function paint() {
      paintImprint();
      paintPrice();
    }
    box._ezinkPaint = paint;

    if (deco) deco.addEventListener("change", paint);
    if (locSel) locSel.addEventListener("change", paint);
    if (methodSel) methodSel.addEventListener("change", paint);
    document.addEventListener("change", function (e) {
      var t = e.target;
      if (!t || !root.contains(t)) return;
      if (t.classList && t.classList.contains("single-option-selector")) paintPrice();
    });
    if (w.jQuery) {
      w.jQuery(root).on("variantChange", paintPrice);
    }
    paint();
    setTimeout(paintPrice, 80);
    setTimeout(paintPrice, 400);
  }

  function boot() {
    if (typeof document === "undefined") return;
    document.querySelectorAll("[data-section-type='product']").forEach(init);
  }

  var api = {
    promoQuote: promoQuote,
    dollarsToCents: dollarsToCents,
    paint: function (root) {
      if (!root) return;
      var box = root.querySelector("[data-ezink-promo-config]");
      if (box && typeof box._ezinkPaint === "function") {
        box._ezinkPaint();
        return;
      }
      init(root);
    }
  };
  w.EZINKPromo = api;
  if (typeof module !== "undefined" && module.exports) module.exports = api;

  if (typeof document === "undefined") return;
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})(typeof window !== "undefined" ? window : {});
